export const API_PATH = {
  DELETE_LIST_PRODUCT: 'pharmacy/product/delete/list',
  GET_TOKEN: '/oauth/token'
}
